module.exports = __webpack_public_path__ + "img/32.fixed_door.8137deb3.svg";